query DocumentShareLists {
  userDocumentShareLists {
    nodes {
      groupId
      groupName
      channelId
      departmentId
      userName
      userId
      sequenceName
      isContactGroup
      isCommunicationGroup
      isDepartmentGroup
      isGroupSelectable
      isGroupHeader
    }
  }
}
